import { render, staticRenderFns } from "./view_user_info.vue?vue&type=template&id=4a857a6a&scoped=true&"
import script from "./view_user_info.vue?vue&type=script&lang=js&"
export * from "./view_user_info.vue?vue&type=script&lang=js&"
import style0 from "./view_user_info.vue?vue&type=style&index=0&id=4a857a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a857a6a",
  null
  
)

export default component.exports